import React, { useEffect, useState } from 'react';
import { LandingPage } from './pages/LandingPage';
import { PasswordGate } from './components/PasswordGate';
const CORRECT_PASSWORD = 'legallama2024';
const AUTH_KEY = 'legallama_authenticated';
export function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  useEffect(() => {
    // Check if user was previously authenticated
    const authStatus = sessionStorage.getItem(AUTH_KEY);
    if (authStatus === 'true') {
      setIsAuthenticated(true);
    }
  }, []);
  const handleAuthenticate = (password: string) => {
    if (password === CORRECT_PASSWORD) {
      setIsAuthenticated(true);
      sessionStorage.setItem(AUTH_KEY, 'true');
    }
  };
  if (!isAuthenticated) {
    return <PasswordGate onAuthenticate={handleAuthenticate} data-id="element-0" />;
  }
  return <LandingPage data-id="element-1" />;
}